import router from '@/router'
import { getPageByMenu } from '@/router/role_page'

import {
  saveData,
  getData
} from '@/cllib/local_storage'

import {
  wxauth,
  userLogOut,
  getUserInfo,
  userGetUserDriver,
  interfaceStatusGetData
  // getTokenByCode
} from '@/api/api'

import {
  findDataFormTree
} from '@/cllib/tools'

const state = {
  authPass: false,
  token: null,
  authBeforeRouter: '',
  isWeiXinUse: false,
  weiXinCode: null,
  urlUserCode: null,
  weiXinGoUrl: null,
  jmpData: null
}

const getters = {
  token: state => state.token,
  isWeiXinUse: state => state.isWeiXinUse,
  weiXinCode: state => state.weiXinCode,
  weiXinGoUrl: state => state.weiXinGoUrl,
  urlUserCode: state => state.urlUserCode,
  authPass: state => state.authPass,
  authBeforeRouter: state => state.authBeforeRouter,
  jmpData: state => state.jmpData
}

const actions = {
  setAuthPass ({ commit, dispatch }, data) {
    commit('setAuthPass', data)
    if (data) {
      // 获取用户信息成功
      dispatch('goFirstPage')
    } else {
      // 获取用户信息失败
      dispatch('userOAuth')
    }
  },
  userOAuth ({ getters }) {
    // 用户赋权
    if (getters.isWeiXinUse && !getters.weiXinCode) {
      if (!window.weiXinAuthIng) {
        window.weiXinAuthIng = true
        let redirectUri = encodeURI(window.location.href.split('wx=1').join('wx=1'))
        let appid = 'wx8e9c11d0943467ca'
        window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + appid + '&redirect_uri=' + redirectUri + '&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect'
      }
    } else {
      router.push({name: 'account.login'})
    }
  },
  logOut ({ dispatch, commit, getters }) {
    userLogOut()
    saveData({key: 'token', data: ''})
    commit('setToken', null)
    dispatch('setUserInfo', {})
    let routerData = {
      name: 'account.login'
    }
    if (getters.isWeiXinUse) {
      routerData.query = {
        wx: 1
      }
    }
    router.push(routerData)
    setTimeout(() => {
      window.location.reload()
    }, 200)
  },
  goFirstPage ({ getters, dispatch }) {
    if (getters.weiXinGoUrl && !getters.weiXinGoUrl.includes('auth')) {
      window.location.href = getters.weiXinGoUrl
      return
    }

    if (getters.isWeiXinUse) {
      let isDdy = false
      if (getters.userInfo && getters.userInfo.roles && getters.userInfo.roles.length > 0) {
        getters.userInfo.roles.forEach((item) => {
          if (item.name.includes('调度')) {
            isDdy = true
          }
        })
      }
      if (isDdy) {
        router.push({name: 'weixin.business.menus'})
      } else if (getters.userDriverList.length > 0 && (!getters.currentRole || ['驾驶员', '司机'].includes(getters.currentRole.name))) {
        // 配送单列表页
        router.push({name: 'weixin.business.distribution_list'})
      } else if (getters.currentRole && getters.currentRole.name.includes('车队')) {
        router.push({name: 'weixin.business.car_list'})
        // 车辆列表页
      } else {
        // 加油站列表页
        router.push({name: 'weixin.business.gas_list'})
      }
      return
    }
    if (getters.jmpData) {
      let findData = findDataFormTree({data: getters.jmpData, dataKey: 'id', tree: getters.availableMenus, childKey: 'children'})
      if (findData) {
        if (findData.type === 'sys_page') {
          router.push({name: findData.url})
          return
        } else if (findData.type === 'out_page') {
          dispatch('setOutPageUrl', findData.url)
          router.push({name: 'business.out_page'})
          return
        }
      }
    }
    if (getters.authBeforeRouter && getters.authBeforeRouter.name !== 'home') {
      router.push({name: getters.authBeforeRouter.name, query: getters.authBeforeRouter.query})
      return
    }
    router.push(getPageByMenu())
  },
  async authInit ({ commit, dispatch, getters }) {
    let token = getData('token')
    let authPass = true
    if (!token && getters.weiXinCode) {
      saveData({key: 'isWeiXin', data: '1'})
      dispatch('setIsWeiXinUse', true)
      // 微信赋权完成后跳转过来的
      try {
        let parm = {
          code: getters.weiXinCode
        }
        let data = await wxauth(parm)
        if (data && data.code === 0 && data.data && data.data.token) {
          saveData({key: 'token', data: data.data.token})
          token = data.data.token
        } else {
          saveData({key: 'token', data: ''})
          dispatch('showNoticeMsg', {type: 'warning', title: '系统提示', message: '微信赋权失败，请使用用户名密码登录！'})
          router.push({name: 'account.login'})
          return
        }
      } catch (error) {
        authPass = false
        saveData({key: 'token', data: ''})
        dispatch('showNoticeMsg', {type: 'warning', title: '系统提示', message: '微信赋权失败，请使用用户名密码登录。'})
        router.push({name: 'account.login'})
        return
      }
    }
    if (token && token === 'x_error') {
      router.push({name: 'no_permission_page'})
      return
    }
    if (token) {
      commit('setToken', token)
      try {
        let data = await getUserInfo()
        dispatch('getWebVersion')
        dispatch('setUserData', data)
        if (getters.isWeiXinUse && (!getters.currentRole || ['驾驶员', '司机'].includes(getters.currentRole.name))) {
          let driverList = await userGetUserDriver()
          dispatch('setUserDriverList', driverList)
        }
      } catch (error) {
        saveData({key: 'token', data: ''})
        authPass = false
      }
    } else {
      saveData({key: 'token', data: ''})
      authPass = false
    }
    dispatch('setAuthPass', authPass)
  },
  getWebVersion () {
    interfaceStatusGetData('web_version').then((data) => {
      if (data && data.interfaceFlag === 'web_version' && data.interfaceSwitch === 'on' && data.interfaceDate) {
        let webVersion = getData('web_version')
        if (!webVersion || webVersion !== data.interfaceDate) {
          saveData({key: 'web_version', data: data.interfaceDate})
          window.location.reload()
        }
      }
    })
  },
  setAuthBeforeRouter ({ commit }, data) {
    commit('setAuthBeforeRouter', data)
  },
  setWeiXinGoUrl ({ commit }, data) {
    commit('setWeiXinGoUrl', data)
  },
  setIsWeiXinUse ({ commit }, data) {
    commit('setIsWeiXinUse', data)
  },
  setWeiXinCode ({ commit }, data) {
    commit('setWeiXinCode', data)
  },
  setUrlUserCode ({ commit }, data) {
    commit('setUrlUserCode', data)
  },
  setJmpData ({ commit }, data) {
    commit('setJmpData', data)
  }
}

const mutations = {
  setAuthPass (state, data) {
    state.authPass = data
  },
  setJmpData (state, data) {
    state.jmpData = data
  },
  setUrlUserCode (state, data) {
    state.urlUserCode = data
  },
  setWeiXinCode (state, data) {
    state.weiXinCode = data
  },
  setAuthBeforeRouter (state, data) {
    state.authBeforeRouter = data
  },
  setToken (state, data) {
    state.token = data
  },
  setWeiXinGoUrl (state, data) {
    state.weiXinGoUrl = data
  },
  setIsWeiXinUse (state, data) {
    state.isWeiXinUse = data
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/auth.js